import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";

export default function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-tabpanel-${index}`}
            aria-labelledby={`scrollable-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box style={{ padding: 0 }}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
